import React, { Component } from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import moment from "moment";
import { DATETIME_SEARCH_FORMAT } from "../../const";
import "react-datepicker/dist/react-datepicker.css";


const CustomInput = ({ placeholderText, disabled, value = "", onClick }) => (
  <input
    type="text"
    readOnly={true}
    disabled={disabled}
    className="form-control"
    placeholder={placeholderText}
    value={value}
    onClick={onClick}
  />
);
export default class DatePickerComponent extends Component {
  constructor(props) {
    super(props);
    // if (props.selected) {
    //   setTimeout(() => {
    //     this.setState({ date: props.selected });
    //   }, 1);
    // }
  }

  state = {
    date: "",
    visaLang:""
  };

  
  onDateChange = (date) => {
    // this.setState({ date }, () => {
    if (this.props.onChange) {
      const d = date
        ? moment.utc(date).add(7, "hours").format(DATETIME_SEARCH_FORMAT)
        : "";
      this.props.onChange(d);
    }
    // })
  };

  render() {
    const { selected,visa } = this.props;
    const { date } = this.state;
    const {
      className,
      minDate,
      maxDate,
      placeholderText,
      disabled,
      dateFormat = "dd/MM/yyyy HH:mm",
      showTimeSelect = true,
      required = false,
      popperPlacement,
      datePrevious = 15,
    } = this.props;

    // registerLocale("lang",visa)
   
    return (
      <DatePicker
        selected={selected || date}
        className={`form-control date-picker ${className}`}
        onChange={this.onDateChange}
        showTimeSelect={showTimeSelect}
        shouldCloseOnSelect={true}
        dateFormat={dateFormat}
        required={required}
        minDate={minDate}
        maxDate={maxDate}
        popperPlacement={popperPlacement}
        disabled={disabled}
        showMonthDropdown
        showYearDropdown
        dateFormatCalendar="MMMM"
        // locale={"lang"}
        yearDropdownItemNumber={datePrevious}
        scrollableYearDropdown
        customInput={
          <CustomInput placeholderText={placeholderText} disabled={disabled} />
        }
        customInputRef="date"
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: "viewport",
          },
        }}
      />
    );
  }
}
